export const listQuickView = {
  data: [
    {
      partnerId: 8,
      code: "AXA",
      name: "AXA",
    },
    {
      partnerId: 26,
      code: "BAOVIET",
      name: "Bao Viet",
    },
    {
      partnerId: 40,
      code: "GEGI",
      name: "Great Eastern General Insurance",
    },
    {
      partnerId: 7,
      code: "LOLI",
      name: "Lojaya Life Insurance",
    },
    {
      partnerId: 34,
      code: "MSIG",
      name: "MSIG",
    },
    {
      partnerId: 46,
      code: "MSIGVN",
      name: "MSIG Vietnam",
    },
    {
      partnerId: 2,
      code: "SIMAS",
      name: "Simas Insurtech",
    },
    {
      partnerId: 6,
      code: "ALLIANZ",
      name: "Zurich",
    },
  ],
  meta: {
    total: 8,
  },
  status: "200",
  message: "success list partners",
};

export const listProductCategory = {
  data: [
    {
      id: 1,
      code: "MV_CAR",
      name: "Car",
    },
    {
      id: 2,
      code: "Q_CARE",
      name: "Q-Care",
    },
  ],
  meta: {
    total: 1,
  },
  status: "200",
  message: "success list product category",
};
